import React from 'react'
import {URL as NEWURL} from '../constants';
import {VENDORID as NEWVENDORID} from '../constants';
import { ReactComponent as SaveIcon } from '../assets/pic/save.svg';
import { RefreshIcon } from '@heroicons/react/solid';
import fetchItemsFromAPI from '../fetch/fetchItemsFromAPI';
import LoadingOverlay from '../components/ProcessLoading';
import { useState } from 'react';


export default function SlipRefresh() {
  const [pressed, setPressed] = useState(false);

  async function onSlipRefresh() {
    setPressed(true);
    const token = sessionStorage.getItem("token");

    try {
      await fetchItemsFromAPI(token);
      window.location.reload();
    } catch (error) {
      console.error("Refresh failed:", error);
    } finally {
      setPressed(false);
    }
  }

  return (
    <>
      <button
        className="h-8 w-8 flex items-center justify-center rounded-md border border-transparent bg-company-primary-color p-1 text-base font-medium text-white shadow-sm hover:opacity-75"
        type="button"
        onClick={onSlipRefresh}
        disabled={pressed}
      >
        <RefreshIcon className="w-4 h-4 fill-white" />
      </button>

      {pressed && <LoadingOverlay />}
    </>
  );
}
